<template>
  <div class="the-class-roster">
    <div class="class-info-wrap">
      <div class="class-info">
        <span>
          {{ $t('public.class') }}{{ $t('public.colon') }}{{ classInfo.name }}
        </span>
        <span>
          {{ $t('public.teacher') }}{{ $t('public.colon')
          }}{{ classInfo.teacherName }}
        </span>
        <span>
          {{ $t('public.grade') }}{{ $t('public.colon')
          }}{{ classInfo.grade == 9 ? 'pre-10' : classInfo.grade }}
        </span>
        <span>
          {{ $t('public.studentNumberO') }}{{ $t('public.colon')
          }}{{ classInfo.number }}
        </span>
      </div>

      <div class="operation">
        <template v-if="handleRightsList.includes('编辑花名册')">
          <a-button type="primary" @click="addStudent">
            {{ $t('public.add', { content: $t('public.student_lower') }) }}
          </a-button>
          <a-button @click="changeStudent">
            {{ $t('public.change', { content: $t('public.class_lower') }) }}
          </a-button>
          <a-button type="danger" @click="deleteStudent">
            {{ $t('public.delete', { content: $t('public.student_lower') }) }}
          </a-button>
        </template>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
      size="middle"
      :rowKey="(record) => record.id"
      :scroll="{ x: 1000 }"
      :loading="tableLoading"
      :dataSource="dataSource"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: selectChange,
      }"
      :pagination="false"
    >
      <a-table-column
        :title="$t('public.studentId')"
        dataIndex="studentNo"
      ></a-table-column>

      <a-table-column :title="$t('public.name')" dataIndex="name">
        <template slot-scope="name, record">
          {{ record.name }} {{ record.surname }} {{ record.givenName }} ({{
            record.englishName
          }})
          <!-- <span
            class="name"
            :class="
              record.studentStatus == 3
                ? 'QS'
                : record.studentStatus == 4
                ? 'DO'
                : 'GRA'
            "
            v-if="
              record.studentStatus == 3 ||
                record.studentStatus == 4 ||
                record.studentStatus == 5
            "
            >{{
              record.studentStatus == 3
                ? $t('public.quitSchool')
                : record.studentStatus == 4
                ? $t('public.dropOut')
                : record.studentStatus == 5
                ? $t('public.graduation')
                : ''
            }}</span
          > -->
        </template>
      </a-table-column>

      <a-table-column
        :title="$t('public.dateOfBirth')"
        dataIndex="birthdate"
      ></a-table-column>

      <a-table-column
        :title="$t('public.enrollmentTime')"
        dataIndex="enrollDate"
      ></a-table-column>

      <a-table-column
        :title="$t('public.enrollmentGradeTitle')"
        dataIndex="enrollGrade"
      >
        <template slot-scope="enrollGrade">
          {{ enrollGrade | filteGrade('name') }}
        </template>
      </a-table-column>

      <a-table-column
        :title="$t('public.currentGrade')"
        dataIndex="currentGrade"
      >
        <template slot-scope="currentGrade">
          {{ currentGrade | filteGrade('name') }}
        </template>
      </a-table-column>
    </a-table>

    <!-- 编辑学生 -->
    <a-modal
      :title="$t('public.student')"
      v-model="modalVisible"
      :maskClosable="false"
      :width="800"
      :bodyStyle="{
        paddingTop: '12px',
        paddingBottom: 0,
      }"
      :confirmLoading="modalLoading"
      @ok="ok"
      :afterClose="afterClose"
    >
      <a-form :form="form">
        <a-form-item
          label=""
          :labelCol="{ span: 0 }"
          :wrapperCol="{ span: 24 }"
        >
          <a-transfer
            showSearch
            :lazy="false"
            :listStyle="{
              height: '400px',
              width: '330px',
            }"
            :targetKeys="studentSelected"
            :dataSource="studentDataSource"
            :operations="[$t('handle.add'), $t('handle.delete')]"
            :titles="[$t('public.unselected'), $t('public.selected')]"
            :render="renderStudentItem"
            v-decorator="[
              'student',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseChoose', {
                      content: $t('public.student_lower'),
                    }),
                  },
                ],
              },
            ]"
            @change="studentChange"
          >
          </a-transfer>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      :width="600"
      :title="$t('public.add', { content: $t('public.student_lower') })"
      :visible="visibleAddStudent"
      :confirm-loading="confirmLoadingAddStudent"
      @ok="handleOkAddStudent"
      @cancel="
        () => {
          visibleAddStudent = false
        }
      "
    >
      <div class="search">
        <a-input-search
          enter-button="Search"
          @search="onSearchStudentName"
          :placeholder="
            $t('public.searchList', { content: $t('public.student_lower') })
          "
        />
      </div>
      <a-table
        :pagination="{
          total: total,
          pageSize: pageSize,
          current: current,
          showSizeChanger: true,
          pageSizeOptions: ['25', '50', '100'],
          showTotal: (total) =>
            $t('public.page', { total: total, pageSize: pageSize }),
          onChange: currentChange,
          onShowSizeChange: showSizeChange,
        }"
        size="middle"
        :rowKey="(record) => record.id"
        :loading="tableLoading"
        :dataSource="studentDataSource"
        :rowSelection="{
          selectedRowKeys: selectedRowKeysAddStudent,
          onChange: selectChangeAddStudent,
        }"
      >
        <a-table-column
          :title="$t('public.studentId')"
          dataIndex="studentNo"
        ></a-table-column>
        <a-table-column
          :title="$t('public.name_lower')"
          dataIndex="name"
        ></a-table-column>
      </a-table>
    </a-modal>
    <!-- 更换班级 -->
    <a-modal
      :title="$t('public.change', { content: $t('public.class_lower') })"
      :visible="visibleChangeClass"
      :confirm-loading="confirmLoadingChangeClass"
      @ok="handleOkChangeClass"
      @cancel="
        () => {
          visibleChangeClass = false
        }
      "
    >
      <div class="searchClassBox">
        <!-- <a-auto-complete
          allowClear
          autoFocus
          :dropdown-match-select-width="false"
          :dropdown-style="{ width: '300px' }"
          size="large"
          style="width: 100%"
          placeholder="input here"
          option-label-prop="value"
          @change="searchNameCallback"
        >
          <template slot="dataSource">
            <a-select-opt-group v-for="group in searchData" :key="group.title">
              <span slot="label">
                {{ group.label }}
              </span>
              <a-select-option
                v-for="opt in group.children"
                :key="opt.title"
                :value="opt.title"
              >
                {{ opt.title }}
              </a-select-option>
            </a-select-opt-group>
          </template>
        </a-auto-complete> -->
        <a-form-item
          :labelCol="{ span: 3 }"
          :wrapperCol="{ span: 21 }"
          :label="$t('class.administrativeClass')"
        >
          <a-select
            v-model="selectAdministrative"
            :placeholder="$t('class.messageDesc')"
            style="width: 90%"
            @change="handleChangeAdministrative"
          >
            <a-select-option
              v-for="item in administrativeData"
              :value="item.id"
              :key="item.id"
              :disabled="item.name == currentClassName"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="{ span: 3 }"
          :wrapperCol="{ span: 21 }"
          :label="$t('class.electiveClass')"
        >
          <a-select
            v-model="selectElectiveItemData"
            :placeholder="$t('class.messageDesc')"
            style="width: 90%"
            @change="handleChangeEletive"
          >
            <a-select-option
              v-for="item in electiveData"
              :value="item.id"
              :key="item.id"
              :disabled="item.name == currentClassName"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      selectAdministrative: undefined,
      selectElectiveItemData: undefined,
      administrativeData: [],
      electiveData: [],
      selectedRowKeysAddStudent: [],
      confirmLoadingDeleteStudent: false,
      visibleDeleteStudent: false,
      confirmLoadingChangeClass: false,
      confirmLoadingAddStudent: false,
      visibleChangeClass: false,
      visibleAddStudent: false,
      campusId: localStorage.getItem('campusId'),

      tableLoading: false,
      classInfo: {},
      dataSource: [],
      selectedRowKeys: [],

      // 编辑学生
      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      studentSelected: [],
      studentDataSource: [],
      current: 1,
      pageSize: 25,
      total: 1,
      studentName: null,
      currentClass: 1,
      pageSizeClass: 25,
      totalClass: 1,
      classData: [],
      searchClassWord: null,
      currentClassName: null,
    }
  },

  props: {
    itemId: {
      default: '',
    },
  },

  computed: {
    ...mapGetters(['handleRightsList']),
  },

  created() {
    this.getClassesDetail()
    this.getStudentList()
  },

  methods: {
    handleChangeAdministrative(value) {
      this.selectAdministrative = value
      this.selectElectiveItemData = undefined
    },
    handleChangeEletive(value) {
      this.selectElectiveItemData = value
      this.selectAdministrative = undefined
    },
    searchNameCallback(val) {
      this.searchClassWord = val
      this.getClassArrMe()
      // this.studentName = val
      // this.getStudentList()
    },
    //搜索学生姓名
    onSearchStudentName(val) {
      this.current = 1
      this.studentName = val
      this.getStudentList()
    },
    currentChange(val) {
      this.current = val
      this.getStudentList()
    },
    showSizeChange(current, size) {
      this.current = 1
      this.pageSize = size
      this.getStudentList()
    },
    selectChangeAddStudent(selectedRowKeysAddStudent) {
      this.selectedRowKeysAddStudent = selectedRowKeysAddStudent
    },
    handleOkAddStudent() {
      if (this.selectedRowKeysAddStudent.length == 0) {
        this.$message.error(this.$t('class.messageClass'))
        return false
      }
      let data = {
        classId: this.itemId,
        studentIds: JSON.stringify(this.selectedRowKeysAddStudent),
      }
      this.$http(this.$api.addStudentIntoClass, data).then((r) => {
        this.getClassesDetail()
        this.selectedRowKeysAddStudent = []
      })
    },
    deleteStudent() {
      // this.visibleDeleteStudent = true
      if (this.selectedRowKeys.length == 0) {
        this.$message.error(this.$t('class.messageClass'))
        return false
      }
      let that = this
      this.$confirm({
        title: that.$t('week.confirmDelete', {
          content: that.$t('grades.currentStudent'),
        }),
        content: that.$t('week.confirmDelete', {
          content: that.$t('grades.currentStudent'),
        }),
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          let data = {
            classId: that.itemId,
            studentIds: JSON.stringify(that.selectedRowKeys),
          }
          that
            .$http(that.$api.deleteStudentClass, data)
            .then((r) => {
              that.getClassesDetail()
              that.$message.success(this.$t('public.deleteSuccess'))
              that.selectedRowKeys = []
            })
            .catch(() => {
              that.selectedRowKeys = []
            })
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    },
    handleOkChangeClass() {
      if (!this.selectAdministrative && !this.selectElectiveItemData) {
        this.$message.error(this.$t('class.messageClass'))
        // that.$message.success(this.$t('public.deleteSuccess'))
        return false
      }
      let data = {
        classId: this.itemId,
        id: this.selectAdministrative
          ? this.selectAdministrative
          : this.selectElectiveItemData,
        studentIds: JSON.stringify(this.selectedRowKeys),
      }
      this.$http(this.$api.ChangeStudentClass, data).then(() => {
        this.$message.success(this.$t('public.saveSuccess'))
        this.getClassesDetail()
        this.selectedRowKeys = []
        this.visibleChangeClass = false
      })
    },
    changeStudent() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error(this.$t('class.messageClass'))
        return false
      }
      this.getClassArrMe()
      this.visibleChangeClass = true
    },
    getClassArrMe() {
      let data = {
        // pageSize: this.pageSizeClass,
        // pageNo: this.currentClass,
        name: this.searchClassWord,
      }
      this.$http(this.$api.getClassArrData, data).then((r) => {
        // console.log(r.data.rows)
        this.administrativeData = r.data.administrative
        this.electiveData = r.data.elective
        // this.classData = r.data.rows
        this.totalClass = r.data.totalClass
      })
    },
    addStudent() {
      this.visibleAddStudent = true
    },
    // 班级详情
    getClassesDetail() {
      this.$http(this.$api.GETCLASSESDETAIL, {
        id: this.itemId,
      }).then((r) => {
        this.classInfo = r.data
        this.dataSource = r.data.students
        this.currentClassName = r.data.name
        this.studentSelected = r.data.students.map((item) => {
          return item.id.toString()
        })
      })
    },

    // 所有学生
    getStudentList() {
      this.$http(this.$api.GETSTUDENTMESSAGE, {
        campusId: this.campusId,
        pageNo: this.current,
        pageSize: this.pageSize,
        name: this.studentName,
      }).then((r) => {
        this.studentDataSource = (r.data.rows || []).map((item) => {
          return {
            ...item,
            key: item.id.toString(),
            title: `${item.name} ${item.surname} ${item.givenName} (${item.englishName})`,
          }
        })
        this.total = r.data.total
      })
    },

    // 渲染学生
    renderStudentItem(item) {
      let student = null
      if (item.gender) {
        student = (
          <span>
            <span> {item.title} </span>{' '}
            <a-
              icon
              style={{
                'margin-left': '10px',
                'font-size': '20px',
                display: item.gender ? '' : 'none',
                color: this.$utils.filteGender(item.gender, 'color'),
              }}
              type={this.$utils.filteGender(item.gender, 'icon')}
            />{' '}
          </span>
        )
      } else {
        student = <span> {item.title} </span>
      }

      return {
        label: student,
        value: item.title,
      }
    },

    // 选中学生
    studentChange(targetKeys) {
      this.studentSelected = targetKeys
    },
    //编辑学术
    editStudent() {
      // this.modalVisible = true
    },

    ok() {
      this.form.validateFields((err) => {
        if (!err) {
          this.saveClassStudent()
        }
      })
    },

    saveClassStudent() {
      this.modalLoading = true

      const studentSelected = this.studentSelected.map((item) => {
        return Number(item)
      })

      this.$http(this.$api.SAVECLASSSTUDENT, {
        campusId: this.campusId,
        classId: this.itemId,
        studentIds: JSON.stringify(studentSelected),
      })
        .then(() => {
          this.$message.success(this.$t('public.saveSuccess'))
          this.getClassesDetail()
          this.modalVisible = false
        })
        .catch(() => {
          this.modalLoading = false
        })
    },

    afterClose() {
      this.modalLoading = false
      this.selectedRowKeys = []
    },

    // 多选
    selectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
  },
}
</script>

<style lang="less" scoped>
.the-class-roster {
  .class-info-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    .class-info {
      display: flex;

      & > span {
        margin-right: 15px;
      }
    }
    .operation {
      display: flex;
      .ant-btn:nth-child(1) ~ .ant-btn {
        margin-left: 10px;
      }
    }
  }

  /deep/ .ant-table-tbody {
    .name {
      margin-left: 8px;
      display: inline-block;
      padding: 2px 3px;

      color: white;
      border-radius: 5px;
    }

    //休学
    // .QS {
    //   background-color: #ff9933;
    // }

    // //退学
    // .DO {
    //   background-color: #ff6666;
    // }

    // .GRA {
    //   background-color: #707070;
    // }
  }
}
/deep/ .ant-table-body {
  overflow-x: hidden !important;
}
.search {
  width: 300px;
  display: flex;
  height: 60px;
  align-items: center;
}
.searchClassBox {
  // width: 300px;
  // height: 400px;
  // display: flex;
  // align-items: center;
}
.ant-btn-danger {
  background-color: #f5222d;
  color: white;
}
.ant-btn-danger:hover {
  background-color: #ec5b56;
}
</style>
